export const objectHasValues = (object: Record<string, unknown>): boolean => {
	const sanitized = Object.fromEntries(Object.entries(object).filter(([, value]) => value));

	return Object.keys(sanitized).length > 0;
};
